import { languageFlag } from '@foyer/shared';
import ar from 'flag-icons/flags/4x3/sa.svg';
import de from 'flag-icons/flags/4x3/de.svg';
import en from 'flag-icons/flags/4x3/gb.svg';
import fr from 'flag-icons/flags/4x3/fr.svg';
import it from 'flag-icons/flags/4x3/it.svg';
import nl from 'flag-icons/flags/4x3/nl.svg';
import ro from 'flag-icons/flags/4x3/ro.svg';
import ru from 'flag-icons/flags/4x3/ru.svg';
import tr from 'flag-icons/flags/4x3/tr.svg';

/**
 * Flag next to a language name in the language switch.
 *
 * Images, not emoji: Windows renders flag emoji as two letters ("DE"), which
 * is exactly the tablet a reception desk tends to have. The files are bundled
 * by Vite, so the switch looks the same when the lobby WLAN is down.
 */
const FLAGS: Record<string, string> = { sa: ar, de, gb: en, fr, it, nl, ro, ru, tr };

export function Flag({ language }: { language: string }): JSX.Element | null {
  const country = languageFlag(language);
  const src = country ? FLAGS[country] : undefined;
  if (!src) return null;
  // Decorative: the language name next to it is what a screen reader reads.
  return <img className="flag" src={src} alt="" aria-hidden="true" width={28} height={21} />;
}
